

































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import DashboardModule, { MODULE_ID } from "../..";
import { MenuItem } from "@abaco/web-common/src/app/Application";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";

@Component({
    components: {}
})
export default class HeaderMaltaMainButton extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Inject(MODULE_ID) DashboardModule!: DashboardModule;
    @Inject(SSOModule.MODULE_ID) ssoModule!: SSOModule;

    @Prop() homePage!: MenuItem;

    private colorDarkBlue = "#269eb1";
    private colorGreen = "#2bb572";
    private colorLightBlue = "#72b4c4";
    private widthSize: string | null = null;
    private heightSize: string | null = "34px";

    private get colorTop() {
        return this.colorDarkBlue;
    }
    private get colorBottom() {
        return this.colorLightBlue;
    }
    private sizeStyle = {
        width: this.widthSize ? this.widthSize : "auto",
        height: this.heightSize ? this.heightSize : "auto"
    };
}
